import { CompactSelect } from '@/components/ui/CompactSelect'
import { useToast } from '@/components/ui/Toast'
import { HomeIcon } from '@/components/ui/icons'
import { ApiError } from '@/api/errors'
import { useAuth } from '@/features/auth/authContext'
import { useSwitchLocation } from '@/features/auth/hooks/useSwitchLocation'
import { useTerm } from '@/hooks/useTerm'

/** Shown only to people assigned to more than one location — otherwise there is nothing to pick. */
export function LocationSwitcher() {
  const { location, locations } = useAuth()
  const switchLocation = useSwitchLocation()
  const { showToast } = useToast()
  const locationTerm = useTerm('location')

  if (!location || locations.length < 2) return null

  return (
    <CompactSelect
      label={`${locationTerm.singular} wechseln`}
      icon={<HomeIcon />}
      value={location.publicId}
      disabled={switchLocation.isPending}
      onChange={(event) =>
        switchLocation.mutate(event.target.value, {
          onSuccess: (session) =>
            showToast({
              title: `${locationTerm.singular} gewechselt`,
              description: session.location?.name,
            }),
          onError: (error) =>
            showToast({
              title: 'Wechsel fehlgeschlagen',
              description: ApiError.from(error).message,
              tone: 'error',
            }),
        })
      }
    >
      {locations.map((option) => (
        <option key={option.publicId} value={option.publicId}>
          {option.name}
        </option>
      ))}
    </CompactSelect>
  )
}
